module.exports = __webpack_public_path__ + "img/hxzb-img8.1d44a60c.png";